module.exports = __webpack_public_path__ + "static/media/no-poster.6973fd71.png";